import { Icon, IconName } from "#shared/icons/Icon";
import { Group } from "#shared/view/components/Group";
import { Title } from "#shared/view/components/Title";

type Props = {
  title: string;
  iconName?: IconName;
};

export const TitleWithIcon = ({ title, iconName }: Props) => {
  return (
    <Group gap={"xs"}>
      {iconName && <Icon name={iconName} withBackground={false} />}
      <Title order={3}>{title}</Title>
    </Group>
  );
};
